import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'P: ¿Necesito saber usar IA?',
  a: 'R: No. Hay una guía paso a paso que te lleva desde cero hasta tener el sistema andando en una tarde.'
}, {
  q: 'P: ¿Sirve para cualquier carrera?',
  a: 'R: Sí. Derecho, Medicina, Ingeniería, Psicología, Administración, Arquitectura y más. Los prompts se adaptan a cualquier material académico.'
}, {
  q: 'P: ¿Esto es hacer trampa?',
  a: 'R: No. Es como usar calculadora en vez de hacer cuentas a mano. La IA te ayuda a procesar, organizarte y estudiar mejor. Vos seguís siendo quien entiende y rinde.'
}, {
  q: 'P: ¿Cuándo recibo el acceso?',
  a: 'R: Al toque. En menos de 5 minutos después del pago te llega todo por mail.'
}, {
  q: 'P: ¿Y si no me sirve?',
  a: 'R: Garantía de 7 días. Un mensaje y te devolvemos todo. Sin drama.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-112">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-113">
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-[11px] font-bold tracking-[3px] text-brand-blue uppercase text-center mb-4" data-id="element-114">
          LAS DUDAS MÁS COMUNES
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-8" data-id="element-115">
          Lo que seguro te estás preguntando.
        </motion.h2>

        <div className="flex flex-col gap-3" data-id="element-116">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-navy-2 border border-brand-blue-dark rounded-xl overflow-hidden" data-id="element-117">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full bg-transparent text-white font-sans text-[15px] font-bold text-left py-5 px-6 cursor-pointer flex justify-between items-center gap-3 hover:bg-brand-blue/5 transition-colors" data-id="element-118">
                  <span data-id="element-119">{faq.q}</span>
                  <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="text-brand-blue text-[18px] shrink-0" data-id="element-120">
                    ▾
                  </motion.span>
                </button>
                <AnimatePresence data-id="element-121">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-122">
                      <div className="px-6 pb-5 pt-4 text-[15px] text-brand-gray leading-[1.7] border-t border-brand-blue-dark" data-id="element-123">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}